"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function () {
  // THE SIMULATION ENGINE: LIVE SESSION SYNC. Learner device presses, publishing the patient to
  // sessions/<CODE>/live, the room monitor's listener, presence, the defib mirror and the resume
  // snapshot in this browser.
  // Called by useSimulation (data/engine.js) at a fixed point on every render, so its hooks keep
  // their order. It receives what it uses from the rest of the engine and returns what the rest
  // of the engine uses (both lists generated from a scope analysis of the original code).
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef;
  var RG = window.RHYTHMS;
  var _window$__EngineModel = window.__EngineModel,
    DEFAULT_VITALS = _window$__EngineModel.DEFAULT_VITALS,
    getObstruction = _window$__EngineModel.getObstruction,
    getSensors = _window$__EngineModel.getSensors,
    sanitizeForRealtimeDatabase = _window$__EngineModel.sanitizeForRealtimeDatabase;
  var useSessionSync = function useSessionSync(ctx) {
    var addLogEntry = ctx.addLogEntry,
      analyseRhythm = ctx.analyseRhythm,
      deliverShock = ctx.deliverShock,
      dispatch = ctx.dispatch,
      initCharge = ctx.initCharge,
      isAudioLive = ctx.isAudioLive,
      isMonitorMode = ctx.isMonitorMode,
      lastPayloadRef = ctx.lastPayloadRef,
      postToChannel = ctx.postToChannel,
      sessionID = ctx.sessionID,
      setDefibEnergy = ctx.setDefibEnergy,
      setDefibMode = ctx.setDefibMode,
      simChannel = ctx.simChannel,
      start = ctx.start,
      state = ctx.state,
      stateRef = ctx.stateRef,
      toggleCPR = ctx.toggleCPR;

    // Defib Sim: the clock starts itself at the learner's first action, so a forgotten START
    // does not leave every event in the log at 00:00. Not after a deliberate facilitator pause
    // (pausedAt is set only by PAUSE_SIM), and not for display-only presses.
    // The ventilator's log lines are reports, not presses on the defib.
    var PASSIVE_DEVICE_EVENTS = ['LEAD_CHANGE', 'SIZE_CHANGE', 'ALARM_SILENCE', 'REQUEST_SYNC', 'VENT_LOG', 'CHARGE_CANCEL', 'INVESTIGATION'];
    var autoStartClock = function autoStartClock(type, p) {
      var cur = stateRef.current;
      if (!cur || !cur.scenario || !cur.scenario.defibSim) return;
      if (cur.isRunning || cur.isFinished) return;
      if (cur.pausedAt !== null && cur.pausedAt !== undefined) return;
      if (PASSIVE_DEVICE_EVENTS.indexOf(type) !== -1) return;
      if (type === 'DEVICE_MODE' && p && p.mode === 'off') return;
      // The defib page resets its pacer to 0 mA on load and when it closes: not a learner action.
      if (type === 'PACER_UPDATE' && p && !(Number(p.output) > 0)) return;
      addLogEntry('Clock started automatically at the learner\'s first action on the defibrillator.', 'system');
      start();
    };

    // ONE handler for every press on a learner's defibrillator, however it arrived: over the
    // live session (a tablet anywhere) or the same-browser channel (a defib in another tab).
    // Presses are acted on whether or not the clock is running, so a forgotten START never
    // silently drops a learner's shock (outside Defib Sim, a shock before START is recorded and
    // reaches the patient when START is pressed).
    var handleDeviceEvent = function handleDeviceEvent(type, p, where) {
      var cur = stateRef.current;
      // After Finish the debrief is frozen: a press on a tablet (or a tablet closing) no
      // longer changes the shocks, rhythm or log.
      if (cur.isFinished) return;
      p = p || {};
      var src = "student (".concat(where, ")");
      autoStartClock(type, p);
      switch (type) {
        case 'DEVICE_MODE':
          setDefibMode(p.mode, src);
          break;
        case 'ENERGY_SELECT':
          setDefibEnergy(p.energy, src);
          break;
        case 'SYNC_TOGGLE':
          dispatch({
            type: 'SET_DEFIB_STATE',
            payload: {
              syncMode: !!p.sync
            }
          });
          addLogEntry("SYNC ".concat(p.sync ? 'ON' : 'OFF', " (").concat(src, ")").concat(p.sync && RG.isPulseless(cur.rhythm) ? ' — armed in a pulseless rhythm; the device will not discharge. Flagged.' : ''), p.sync && RG.isPulseless(cur.rhythm) ? 'warning' : 'action', !!(p.sync && RG.isPulseless(cur.rhythm)));
          break;
        case 'CHARGE_INIT':
          initCharge(p.energy);
          break;
        // The tablet dumped or cancelled its charge: the room monitor and the controller stop showing CHARGED.
        case 'CHARGE_CANCEL':
          if (cur.defib && cur.defib.charged) dispatch({
            type: 'SET_DEFIB_STATE',
            payload: {
              charged: false,
              chargeEnergy: null
            }
          });
          break;
        case 'SHOCK_DELIVERED':
          deliverShock(p.energy, src, {
            sync: !!p.sync
          });
          break;
        case 'ANALYSE':
        case 'ANALYSIS_RESULT':
          analyseRhythm(src);
          break;
        // judged here, from the controller's rhythm
        case 'PACER_UPDATE':
          dispatch({
            type: 'UPDATE_PACER_STATE',
            payload: {
              rate: Number(p.rate) || 0,
              output: Number(p.output) || 0,
              demand: p.demand !== false
            }
          });
          break;
        case 'CHECK_PULSE':
          addLogEntry("Student checked pulse (".concat(where, ")"), 'action');
          break;
        // The defib's NIBP key. It measures with the session's one cuff, so in a full scenario
        // the cuff must be attached (Monitoring & access); Defib Sim has no sensor panel, so
        // there the defib's own cuff is always on.
        case 'NIBP_START':
          if (!nibpCuffOn(cur)) {
            addLogEntry("Student pressed NIBP on the defib (".concat(where, ") \u2014 no cuff attached"), 'info');
            break;
          }
          if (!cur.nibp.inflating) {
            dispatch({
              type: 'START_NIBP'
            });
            addLogEntry("NIBP started by student (".concat(where, ")"), 'action');
          }
          break;
        case 'CPR_TOGGLE':
          toggleCPR(!!p.on, src);
          break;
        case 'MARKER_EVENT':
          addLogEntry("Student marked event (".concat(where, ")"), 'manual', true);
          break;
        case 'ALARM_SILENCE':
          addLogEntry("Alarm silenced by student (".concat(where, ")"), 'info');
          break;
        case 'REQUEST_12LEAD':
          addLogEntry("Student requested 12-lead (".concat(where, ")"), 'action');
          break;
        case 'INVESTIGATION':
          {
            var inv = String(p && p.type || '?').slice(0, 12);
            addLogEntry("Team opened the ".concat(inv === 'X-ray' ? 'chest X-ray' : inv, " result on the patient screen"), 'action');
            break;
          }
        case 'LEAD_CHANGE':
          addLogEntry("Monitoring lead changed to ".concat(String(p.lead || '?').slice(0, 8), " (").concat(where, ")"), 'action');
          break;
        case 'SIZE_CHANGE':
          addLogEntry("ECG size x".concat(Number(p.gain) || 1, " (").concat(where, ")"), 'info');
          break;
        // The transport ventilator (vent/index.html): every setting, mode change, test and alarm it
        // records in its own event log is reported here too, as text. Alarms by priority.
        case 'VENT_LOG':
          {
            var text = String(p.text || '').slice(0, 160);
            if (!text) break;
            var pri = {
              hi: 'high',
              med: 'medium',
              low: 'low'
            }[p.p];
            if (p.alarm && pri) addLogEntry("Ventilator alarm (".concat(pri, " priority): ").concat(text, " (").concat(where, ")"), pri === 'low' ? 'info' : 'warning');
            // A change the facilitator made remotely is the facilitator's, not the candidate's.
            else if (p.by === 'facilitator') addLogEntry("Ventilator (facilitator): ".concat(text, " (").concat(where, ")"), 'system');else addLogEntry("Ventilator: ".concat(text, " (").concat(where, ")"), pri ? 'warning' : 'action');
            break;
          }
        default:
          addLogEntry("Unhandled student device event: ".concat(String(type).slice(0, 40)), 'system');
          break;
      }
    };

    // The same-browser channel: registered once; everything is read live through stateRef.
    useEffect(function () {
      if (isMonitorMode || !simChannel.current) return;
      simChannel.current.onmessage = function (event) {
        var data = event.data || {};
        // A defib opened mid-scenario asks for the patient straight away.
        if (data.type === 'REQUEST_SYNC') {
          postToChannel({
            type: 'SYNC_VITALS',
            payload: buildDefibSyncPayloadRef.current()
          });
          return;
        }
        if (data.type === 'SYNC_VITALS' || typeof data.type !== 'string') return;
        handleDeviceEvent(data.type, data.payload, 'standalone defib');
      };
      return function () {
        if (simChannel.current) simChannel.current.onmessage = null;
      };
    }, [isMonitorMode]);

    // The standalone defib page previously received rhythm + 5 numbers and NOTHING
    // else — no weight, no age, no recommended energy, no session-ended flag — which is why it
    // hardcoded 120 J for a 3.5 kg neonate and kept showing a live-looking trace after the end
    // of the session. One builder, used by both the periodic broadcast and REQUEST_SYNC.
    // What the learner's defib is allowed to show. Pulse-check results and RCUK hints are an
    // Education-mode aid in Defib Sim only (a real defibrillator tells you neither).
    var defibViewFor = function defibViewFor(cur) {
      var ds = cur.scenario && cur.scenario.defibSim;
      var edu = !!(ds && ds.mode !== 'assessment');
      return {
        defibSim: !!ds,
        pulseFeedback: edu,
        hints: edu,
        metronome: !!cur.metronomeOn
      };
    };
    // The lungs the ventilator uses (the facilitator's choice, else picked from the scenario),
    // whether the patient breathes for themselves (a paralysed or arrested patient does not,
    // unless the facilitator says so) and what the circuit connects to: a face mask for an awake
    // patient with no airway, else a tube or SGA (recorded, or assumed when unconscious). See
    // data/engine-vent.js (airwayCode).
    var ventConfigFor = function ventConfigFor(cur) {
      var VE = window.VENT_ENGINE;
      if (!VE) return {
        profile: 'normal',
        breathing: null,
        airway: 'tube'
      };
      return _objectSpread(_objectSpread({}, VE.configFor(cur)), {}, {
        airway: VE.airwayCode(cur)
      });
    };
    var DEVICE_WHERE = {
      'standalone-defib': 'standalone defib',
      'monitor-defib': 'monitor defib',
      'monitor-vent': 'ventilator on the monitor',
      'standalone-vent': 'ventilator tablet'
    };
    var nibpCuffOn = function nibpCuffOn(cur) {
      return !!(cur.scenario && cur.scenario.defibSim || getSensors(cur).nibp);
    };
    var buildDefibSyncPayload = function buildDefibSyncPayload() {
      var _cur$scenario, _cur$scenario2, _cur$scenario3, _cur$scenario4, _cur$scenario5;
      var cur = stateRef.current;
      var weight = Number((_cur$scenario = cur.scenario) === null || _cur$scenario === void 0 || (_cur$scenario = _cur$scenario.wetflag) === null || _cur$scenario === void 0 ? void 0 : _cur$scenario.weight);
      var age = (_cur$scenario2 = cur.scenario) === null || _cur$scenario2 === void 0 ? void 0 : _cur$scenario2.patientAge;
      return {
        linked: true,
        sessionID: sessionID || null,
        rhythm: cur.rhythm,
        hr: cur.vitals.hr,
        spO2: cur.vitals.spO2,
        etco2: cur.vitals.etco2,
        bpSys: cur.vitals.bpSys,
        bpDia: cur.vitals.bpDia,
        gain: cur.waveformGain,
        interference: cur.noise.interference,
        cpr: cur.cprInProgress,
        captureThreshold: cur.pacingThreshold,
        audioOutput: cur.audioOutput,
        isRunning: !!cur.isRunning,
        isFinished: !!cur.isFinished,
        patientName: ((_cur$scenario3 = cur.scenario) === null || _cur$scenario3 === void 0 ? void 0 : _cur$scenario3.patientName) || null,
        ageRange: ((_cur$scenario4 = cur.scenario) === null || _cur$scenario4 === void 0 ? void 0 : _cur$scenario4.ageRange) || null,
        patientAge: Number.isFinite(Number(age)) ? Number(age) : null,
        weight: Number.isFinite(weight) && weight > 0 ? weight : null,
        wetflag: ((_cur$scenario5 = cur.scenario) === null || _cur$scenario5 === void 0 ? void 0 : _cur$scenario5.wetflag) || null,
        recommendedEnergy: RG.recommendedEnergy(Number.isFinite(weight) && weight > 0 ? weight : null, age),
        energyLevels: RG.energySteps(Number.isFinite(weight) && weight > 0 ? weight : null, age),
        defib: _objectSpread(_objectSpread({}, cur.defib || {}), {}, {
          runId: cur.runId || null
        }),
        noise: cur.noise || {},
        pacing: {
          electrical: !!(cur.pacing && cur.pacing.electrical),
          mechanical: !!(cur.pacing && cur.pacing.mechanical)
        },
        defibView: defibViewFor(cur),
        // The last CUFF reading (not the live BP): the defib's NIBP only changes when it measures.
        nibp: {
          sys: cur.nibp.sys,
          dia: cur.nibp.dia,
          lastTaken: cur.nibp.lastTaken,
          inflating: !!cur.nibp.inflating,
          cuff: nibpCuffOn(cur)
        },
        // Capnography for the tablet's CO2 trace: attached or not, whether gas is moving,
        // the breath rate and the same shape (pattern + obstruction severity) the monitor draws.
        capno: function () {
          var obstruction = cur.scenario ? getObstruction(cur, cur.vitals, cur.scenario) : null;
          return {
            on: !!cur.etco2Enabled,
            ventilating: RG.capnoVentilating(cur.activeInterventions, cur.vitals.rr, !!cur.cprInProgress),
            rr: Number(cur.vitals.rr) || 0,
            pattern: cur.etco2Pathology || 'normal',
            severity: obstruction && Number.isFinite(obstruction.severity) ? obstruction.severity : 0
          };
        }()
      };
    };
    var buildDefibSyncPayloadRef = useRef(buildDefibSyncPayload);
    buildDefibSyncPayloadRef.current = buildDefibSyncPayload;
    useEffect(function () {
      if (!isMonitorMode) {
        postToChannel({
          type: 'SYNC_VITALS',
          payload: buildDefibSyncPayload()
        });
      }
    }, [state.vitals, state.rhythm, state.waveformGain, state.noise, state.pacingThreshold, state.audioOutput, state.cprInProgress, state.isRunning, state.isFinished, state.scenario, state.defib, state.pacing, state.metronomeOn, state.etco2Enabled, state.etco2Pathology, state.activeInterventions, state.nibp.sys, state.nibp.dia, state.nibp.inflating]);
    useEffect(function () {
      var db = window.db;
      if (!db) {
        var bootstrap = window.firebaseSyncBootstrap || {};
        dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: bootstrap.state === 'unavailable' ? 'unavailable' : 'error',
            message: bootstrap.message || 'Firebase Realtime Database is unavailable.'
          }
        });
        return;
      }
      dispatch({
        type: 'SET_SYNC_STATUS',
        payload: {
          state: 'connecting',
          message: 'Connecting to live session…'
        }
      });
      var connectionRef = db.ref('.info/connected');
      var onConnection = function onConnection(snap) {
        if (snap.val() === true) {
          // After a reconnect, send the whole patient again rather than a diff against what
          // the server held before the drop (it may have been deleted meanwhile).
          lastPayloadRef.current = {};
          dispatch({
            type: 'SET_SYNC_STATUS',
            payload: {
              state: 'connected',
              message: null
            }
          });
        } else {
          dispatch({
            type: 'SET_SYNC_STATUS',
            payload: {
              state: 'disconnected',
              message: 'Realtime Database connection is unavailable.'
            }
          });
        }
      };
      var onConnectionError = function onConnectionError(error) {
        console.error('Firebase connection-state listener failed:', error);
        dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: 'error',
            message: "Firebase connection error: ".concat(error.message || 'unknown error')
          }
        });
      };
      connectionRef.on('value', onConnection, onConnectionError);
      return function () {
        return connectionRef.off('value', onConnection);
      };
    }, []);

    // Firebase sync — throttled to 500ms; reads live state from stateRef so we don't depend on
    // the whole `state` object identity (which changes every render).
    var syncTimerRef = useRef(null);
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || isMonitorMode || !state.scenario) return;
      // The patient lives under sessions/<CODE>/live, apart from the device channels
      // (presence, deviceEvents, deviceState, command), so a device's heartbeat or a defib
      // screen update does not re-deliver the whole patient to every monitor.
      var sessionRef = db.ref("sessions/".concat(sessionID, "/live"));
      lastPayloadRef.liveSession = sessionID;
      var flush = function flush() {
        var _cur$scenario$deterio;
        syncTimerRef.current = null;
        var cur = stateRef.current;
        if (!cur.scenario) return;
        var co2Pathology = cur.etco2Pathology || 'normal';
        // The obstruction severity behind the shark fin is computed HERE,
        // from the authoritative controller state, and published as a plain number so the
        // student monitor draws exactly the same capnogram shape the facilitator sees. Never
        // undefined, never NaN: sanitizeForRealtimeDatabase passes a finite number through.
        var obstruction = getObstruction(cur, cur.vitals, cur.scenario);
        var co2Severity = Number.isFinite(obstruction.severity) ? obstruction.severity : 0;
        var payload = {
          vitals: cur.vitals,
          rhythm: cur.rhythm,
          cprInProgress: cur.cprInProgress,
          etco2Enabled: cur.etco2Enabled,
          flash: cur.flash,
          cycleTimer: cur.cycleTimer,
          monitorTimer: cur.monitorTimer,
          scenarioTitle: cur.scenario.title || '',
          patientName: cur.scenario.patientName || '',
          patientAge: cur.scenario.patientAge,
          sex: cur.scenario.sex,
          ageRange: cur.scenario.ageRange,
          wetflag: cur.scenario.wetflag || null,
          pathology: ((_cur$scenario$deterio = cur.scenario.deterioration) === null || _cur$scenario$deterio === void 0 ? void 0 : _cur$scenario$deterio.type) || 'normal',
          // Investigations: enrichScenario writes generated CXR/CT/urine/POCUS reports to
          // scenario.investigations.*, but this payload previously read only the top-level
          // fields — so students saw generic default text in essentially every scenario
          // (CT and POCUS lost in 254/254). Read the generated block and let any top-level
          // override (e.g. the "lung re-expanded" CXR rewrite) win.
          // investigations.ecg deliberately carries the ORIGINAL, un-normalised ecg (STEMI
          // stays STEMI) so the monitor's 12-lead draws ST elevation, while the monitoring
          // trace keeps using the separately-synced normalised `rhythm`.
          investigations: function () {
            var gen = cur.scenario.investigations || {};
            return {
              vbg: cur.scenario.vbg || gen.vbg || null,
              ecg: gen.ecg || cur.scenario.ecg || null,
              chestXray: cur.scenario.chestXray || gen.chestXray || null,
              urine: cur.scenario.urine || gen.urine || null,
              ct: cur.scenario.ct || gen.ct || null,
              pocus: cur.scenario.pocus || gen.pocus || null
            };
          }(),
          activeInterventions: Array.from(cur.activeInterventions),
          nibp: cur.nibp,
          speech: cur.speech,
          soundEffect: cur.soundEffect,
          audioOutput: cur.audioOutput,
          trends: cur.trends,
          arrestPanelOpen: cur.arrestPanelOpen,
          isFinished: cur.isFinished,
          // The assessor's Defib open/close toggle, and the defib device state the
          // student's monitor-hosted defibrillator renders (mode, selected energy, charge
          // state, SYNC, running shock tally).
          //
          // B4 LEAK BARRIER — DO NOT ADD `rhythmEvent`, `lastConversion` OR ANY
          // CONVERSION ANNOUNCEMENT TO THIS PAYLOAD. `notification` below is rendered on
          // the STUDENT monitor; conversion announcements are assessor-only by design and
          // The rules test (tests/specs/rules.spec.js) lists every key this object may carry.
          defibPanelOpen: !!cur.defibPanelOpen,
          // runId rides inside `defib` (a free-form key in the rules) so a ventilator or
          // defib tablet can tell a re-run of the same scenario from the run before it
          // without a database-rules change.
          // screenFront (what the facilitator wants in front on the patient screens) rides
          // in here too, for the same reason: no database-rules change.
          // volume and `started` (false only before the first START) ride inside defib, like runId:
          // live's key list is closed in the database rules and defib is free-form, so the patient
          // screens get them with no rules change. The screens stay blank while the facilitator sets up.
          // ventSimple (the ventilators show big mode buttons instead of the machine) rides here for the same reason.
          defib: _objectSpread(_objectSpread({}, cur.defib || {}), {}, {
            runId: cur.runId || null,
            screenFront: cur.screenFront || null,
            volume: Number.isFinite(cur.volume) ? cur.volume : 1,
            ventSimple: !!(cur.vent && cur.vent.simple),
            started: !!(cur.isRunning || cur.isFinished || cur.pausedAt !== null && cur.pausedAt !== undefined)
          }),
          // The ventilator on the room monitor, and the lungs it ventilates (the
          // facilitator's choice, else one picked from the scenario).
          ventPanelOpen: !!cur.ventPanelOpen,
          vent: ventConfigFor(cur),
          // The defib tablet's pulse-check result (Education) and pacing capture state.
          pacing: {
            electrical: !!(cur.pacing && cur.pacing.electrical),
            mechanical: !!(cur.pacing && cur.pacing.mechanical)
          },
          defibView: defibViewFor(cur),
          monitorPopup: cur.monitorPopup,
          waveformGain: cur.waveformGain,
          noise: cur.noise,
          notification: cur.notification,
          remotePacerState: cur.remotePacerState,
          pacingThreshold: cur.pacingThreshold,
          showWetflag: cur.showWetflag,
          co2Pathology: co2Pathology,
          co2Severity: co2Severity,
          // Top-level keys only — the write diff is shallow and per-key. Never undefined.
          isRunning: !!cur.isRunning,
          audioLive: isAudioLive(cur),
          isMuted: !!cur.isMuted,
          activeLoops: cur.activeLoops || {},
          isParalysed: !!cur.isParalysed,
          // BM / Temp / pH ride inside `vitals` (verified by the sync payload test);
          // activeDrugs and deteriorationMode are top-level, primitives only, never undefined,
          // so sanitizeForRealtimeDatabase passes them through untouched.
          activeDrugs: Array.isArray(cur.activeDrugs) ? cur.activeDrugs : [],
          deteriorationMode: cur.deteriorationMode || 'manual',
          // K+ rides inside `vitals` like temp/bm/ph AND is published as its
          // own TOP-LEVEL key, because the write diff is shallow and per-key: a lab value
          // the student monitor renders must never be undefined or NaN on the wire.
          potassium: cur.vitals && Number.isFinite(cur.vitals.k) ? cur.vitals.k : DEFAULT_VITALS.k,
          // Which sensors are attached already rides on the wire inside
          // `activeInterventions` (the monitor derives them with getSensors), so nothing new
          // is needed for those. Point-of-care readings DO need their own top-level key:
          // primitives only, never undefined, so sanitizeForRealtimeDatabase passes it
          // through untouched. Assessor-only conversion announcements are still absent.
          pocReadings: cur.pocReadings || {},
          // SESSION HYGIENE: when this session last carried live data, rounded to the minute
          // so it adds at most one tiny write a minute. RTDB cannot expire data on its own;
          // a scheduled cleanup job (see README) deletes sessions whose updatedAt is old.
          updatedAt: Math.floor(Date.now() / 60000) * 60000
        };
        var sanitised = sanitizeForRealtimeDatabase(payload);
        var safePayload = sanitised.value || {};
        if (sanitised.dropped.length) {
          var dropped = sanitised.dropped.join(', ');
          console.error("Firebase sync omitted invalid value(s): ".concat(dropped));
          dispatch({
            type: 'SET_SYNC_STATUS',
            payload: {
              state: 'degraded',
              message: "Invalid data omitted from sync: ".concat(dropped)
            }
          });
        }
        // The diff base is the last payload the server accepted FOR THIS CODE. After "New code"
        // (or the daily clean-up deleting the session under an open tab) a diff against the
        // old code's payload sent only the changed keys, so the new session never received
        // vitals and every screen waited forever. A new minute (updatedAt rolls over) also
        // sends the whole patient once, which repairs a server copy deleted underneath us.
        var last = lastPayloadRef.current || {};
        var base = lastPayloadRef.session === sessionID && last.updatedAt === safePayload.updatedAt ? last : {};
        var diff = {};
        for (var key in safePayload) {
          if (JSON.stringify(safePayload[key]) !== JSON.stringify(base[key])) {
            diff[key] = safePayload[key];
          }
        }
        if (Object.keys(diff).length > 0) {
          // Only advance the acknowledged snapshot after RTDB accepts the write. Advancing it
          // before the promise resolves made a permission-denied write look successful forever.
          var sentFor = sessionID;
          sessionRef.update(diff).then(function () {
            // A late acknowledgement from a previous code must not become this code's base.
            if (lastPayloadRef.liveSession !== sentFor) return;
            lastPayloadRef.current = safePayload;
            lastPayloadRef.session = sentFor;
            dispatch({
              type: 'SET_SYNC_STATUS',
              payload: {
                state: sanitised.dropped.length ? 'degraded' : 'connected',
                message: sanitised.dropped.length ? 'Some invalid data was omitted from sync.' : null,
                lastWriteAt: Date.now()
              }
            });
          })["catch"](function (e) {
            console.error("Sync Write Error:", e);
            dispatch({
              type: 'SET_SYNC_STATUS',
              payload: {
                state: 'error',
                message: "Live session write failed: ".concat(e.message || 'unknown error')
              }
            });
          });
        }
      };
      if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
      syncTimerRef.current = setTimeout(flush, 500);
      return function () {
        if (syncTimerRef.current) {
          clearTimeout(syncTimerRef.current);
          syncTimerRef.current = null;
        }
      };
    }, [state.vitals, state.rhythm, state.cprInProgress, state.etco2Enabled, state.flash, state.cycleTimer, state.monitorTimer, state.scenario, state.activeInterventions, state.nibp, state.speech, state.soundEffect, state.audioOutput, state.trends, state.arrestPanelOpen, state.isFinished, state.monitorPopup, state.waveformGain, state.noise, state.notification, state.remotePacerState, state.pacingThreshold, state.showWetflag, state.etco2Pathology, isMonitorMode, sessionID, state.isRunning, state.isMuted, state.volume, state.activeLoops, state.isParalysed, state.activeDrugs, state.deteriorationMode, state.defibPanelOpen, state.defib, state.pacing, state.metronomeOn, state.ventPanelOpen, state.vent, state.screenFront]);
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || !isMonitorMode) return;
      var sessionRef = db.ref("sessions/".concat(sessionID, "/live"));
      var handleUpdate = function handleUpdate(snapshot) {
        var data = snapshot.val();
        // A session holding only presence (a monitor or defib that joined before the
        // controller published anything) has no patient yet: keep waiting rather than
        // applying an empty patient, which crashed the monitor.
        if (data && data.vitals) {
          try {
            dispatch({
              type: 'SYNC_FROM_MASTER',
              payload: data
            });
            dispatch({
              type: 'SET_SYNC_STATUS',
              payload: {
                state: 'connected',
                message: null
              }
            });
          } catch (err) {
            console.error("Sync Error", err);
          }
        } else {
          // The controller took the patient off (no scenario loaded): back to waiting.
          dispatch({
            type: 'LIVE_CLEARED'
          });
        }
      };
      var handleReadError = function handleReadError(error) {
        console.error('Firebase monitor read failed:', error);
        dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: 'error',
            message: "Live session read failed: ".concat(error.message || 'unknown error')
          }
        });
      };
      sessionRef.on('value', handleUpdate, handleReadError);
      return function () {
        return sessionRef.off('value', handleUpdate);
      };
    }, [isMonitorMode, sessionID]);

    // =====================================================================================
    // PRESENCE / CONNECTION INDICATOR.
    // Modelled on the existing syncStatus state machine: the monitor writes a presence child
    // under sessions/<CODE>/presence/<clientId> with an onDisconnect() removal and a 10s
    // heartbeat; the controller reduces the children into state.remotePresence and shows a
    // badge next to the existing sync badge saying WHAT each remote device is displaying.
    // =====================================================================================
    var presenceIdRef = useRef(null);
    if (!presenceIdRef.current) presenceIdRef.current = Math.random().toString(36).slice(2, 10);

    // --- monitor side: announce ourselves and what we are showing. A patient screen reports under
    // its own screen id (kept across reloads, data/simscreens.js) as "screen:<role>", which is how
    // the controller numbers it and lists it in Screens; it says nothing until it has that id.
    var SHOWS = {
      defib: 'defib',
      vent: 'ventilator'
    };
    var localScreen = state.localScreen || null;
    var presenceKey = isMonitorMode && localScreen && localScreen.id ? localScreen.id : null;
    var presenceRole = 'screen:' + (localScreen && localScreen.role || 'all');
    var presenceDisplay = isMonitorMode ? localScreen && SHOWS[localScreen.shows] || (state.arrestPanelOpen ? 'arrest view' : 'patient monitor') : null;
    // What it shows is read through a ref, so a change is one update, not a remove and re-add
    // (which made the screen blink out of the controller's list).
    var presenceNowRef = useRef(null);
    presenceNowRef.current = {
      role: presenceRole,
      display: presenceDisplay
    };
    var presenceWriteRef = useRef(null);
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || !isMonitorMode || !presenceKey) return;
      var ref = db.ref("sessions/".concat(sessionID, "/presence/").concat(presenceKey));
      var write = function write() {
        ref.update({
          role: presenceNowRef.current.role,
          display: presenceNowRef.current.display,
          ua: (navigator.userAgent || '').slice(0, 120),
          ts: Date.now()
        })["catch"](function (e) {
          return console.warn('Presence write failed', e);
        });
      };
      presenceWriteRef.current = write;
      // onDisconnect() is what makes a closed tab / dead tablet disappear promptly; the
      // heartbeat is what makes a WIFI dropout (where onDisconnect never fires) detectable.
      // onDisconnect() is one-shot and the SDK does not re-arm it after a reconnect.
      var connRef = db.ref('.info/connected');
      var onConn = function onConn(snap) {
        if (snap.val() === true) ref.onDisconnect().remove()["catch"](function () {});
      };
      connRef.on('value', onConn);
      write();
      var hb = setInterval(write, 10000);
      return function () {
        presenceWriteRef.current = null;
        clearInterval(hb);
        connRef.off('value', onConn);
        ref.remove()["catch"](function () {});
      };
    }, [isMonitorMode, sessionID, presenceKey]);
    useEffect(function () {
      if (presenceWriteRef.current) presenceWriteRef.current();
    }, [presenceDisplay, presenceRole]);

    // --- controller side: reduce the presence children, expiring stale heartbeats.
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || isMonitorMode) return;
      var ref = db.ref("sessions/".concat(sessionID, "/presence"));
      var STALE_MS = 30000;
      var latest = {};
      var push = function push() {
        var now = Date.now();
        var clients = Object.keys(latest).map(function (k) {
          return _objectSpread({
            id: k
          }, latest[k] || {});
        }).filter(function (c) {
          return Number.isFinite(Number(c.ts)) && now - Number(c.ts) < STALE_MS;
        });
        dispatch({
          type: 'SET_REMOTE_PRESENCE',
          payload: clients
        });
      };
      var onVal = function onVal(snap) {
        latest = snap.val() || {};
        push();
      };
      var onErr = function onErr(e) {
        console.error('Presence read failed:', e);
        dispatch({
          type: 'SET_REMOTE_PRESENCE',
          payload: []
        });
      };
      ref.on('value', onVal, onErr);
      var sweep = setInterval(push, 5000);
      return function () {
        ref.off('value', onVal);
        clearInterval(sweep);
      };
    }, [isMonitorMode, sessionID]);

    // =====================================================================================
    // STUDENT DEVICE EVENTS.
    // sessions/<CODE>/command is a single set() slot already owned by the monitor's NIBP
    // control, so reusing it for defib events would clobber an in-flight NIBP command (and
    // vice versa). Device events therefore get their OWN node with PUSH semantics.
    // Every event converges on the same shared outcome helpers the facilitator uses
    // (initCharge / deliverShock / applyShockOutcome / applyCardioversion).
    // =====================================================================================
    var sendDeviceEvent = function sendDeviceEvent(type) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!isMonitorMode || !sessionID || !window.db) return false;
      var safe = sanitizeForRealtimeDatabase({
        type: type,
        payload: payload,
        ts: Date.now(),
        from: presenceIdRef.current
      });
      if (!safe.value || safe.dropped.length) {
        console.error('Invalid device event not sent:', safe.dropped.join(', '));
        return false;
      }
      try {
        window.db.ref("sessions/".concat(sessionID, "/deviceEvents")).push(safe.value)["catch"](function (e) {
          console.error('Device event send failed:', e);
          dispatch({
            type: 'SET_SYNC_STATUS',
            payload: {
              state: 'error',
              message: "Defib event write failed: ".concat(e.message || 'unknown error')
            }
          });
        });
        return true;
      } catch (e) {
        console.error('Device event send failed:', e);
        return false;
      }
    };
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || isMonitorMode) return;
      var ref = db.ref("sessions/".concat(sessionID, "/deviceEvents"));
      // Only ever act on events newer than this listener, so a re-mount cannot replay a
      // whole arrest's worth of shocks. "Newer" is decided by the push key, not by comparing
      // the tablet's clock with this device's: a tablet whose clock ran a few minutes slow
      // used to have every press silently discarded until the clocks crossed.
      var stale = new Set();
      var primed = false;
      var onChild = function onChild(snap) {
        var ev = snap.val();
        if (!ev || !ev.type) return;
        if (!primed || stale.has(snap.key)) {
          snap.ref.remove()["catch"](function () {});
          return;
        }
        handleDeviceEvent(ev.type, ev.payload, DEVICE_WHERE[ev.device] || 'monitor defib');
        // Consume the event so the queue cannot grow without bound across a long session.
        snap.ref.remove()["catch"](function () {});
      };
      // Everything already queued when this listener attaches is left over from before
      // (a reload, a re-mount): note its keys and throw it away.
      var primeTimer = setTimeout(function () {
        primed = true;
      }, 3000); // offline: never stay deaf
      ref.once('value').then(function (all) {
        all.forEach(function (c) {
          stale.add(c.key);
          return false;
        });
      })["catch"](function () {}).then(function () {
        primed = true;
        clearTimeout(primeTimer);
      });
      var onErr = function onErr(e) {
        console.error('Device event listener failed:', e);
        dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: 'error',
            message: "Defib event read failed: ".concat(e.message || 'unknown error')
          }
        });
      };
      ref.limitToLast(25).on('child_added', onChild, onErr);
      return function () {
        clearTimeout(primeTimer);
        ref.off('child_added', onChild);
      };
    }, [isMonitorMode, sessionID]);

    // THE VENTILATOR BREATHING FOR THE PATIENT (phase 2). While the clock runs, TICK_TIME does
    // the ventilator's second; while it is stopped (before START, a pause) this does, because a
    // ventilated patient's oxygen and CO2 do not wait for START. The log says when the
    // ventilator takes over the obs and when it lets go.
    var ventDriving = !isMonitorMode && !!(window.VENT_ENGINE && window.VENT_ENGINE.driverFor(state));
    var ventActive = ventDriving || !!(state.ventPhys && state.ventPhys.active);
    useEffect(function () {
      // Not after Finish: the debrief's obs and ventilator record are frozen at the end.
      if (isMonitorMode || state.isRunning || state.isFinished || !ventActive) return;
      var id = setInterval(function () {
        return dispatch({
          type: 'TICK_VENT'
        });
      }, 1000);
      return function () {
        return clearInterval(id);
      };
    }, [isMonitorMode, state.isRunning, state.isFinished, ventActive]);
    // The debrief's ventilator record: what the ventilator breathing for the patient measured and
    // was set to, every 15 s of real time (data/ventsim.js reads it).
    useEffect(function () {
      if (isMonitorMode || !ventDriving || state.isFinished) return;
      var take = function take() {
        var cur = stateRef.current;
        if (cur.isFinished) return;
        var d = window.VENT_ENGINE && window.VENT_ENGINE.driverFor(cur);
        if (!d) return;
        var mon = d.mon || {};
        var set = {};
        try {
          (JSON.parse(d.sv || '[]') || []).forEach(function (r) {
            if (Array.isArray(r)) set[r[0]] = Number(r[2]);
          });
        } catch (e) {
          set = {};
        }
        var num = function num(v) {
          return Number.isFinite(Number(v)) ? Number(v) : null;
        };
        var niv = ['NIV', 'NIV-ST', 'HiFlowO2'].indexOf(d.mode) !== -1;
        var drive = num(set.pinsp) !== null ? set.pinsp : num(set.ps);
        var t = Number.isFinite(cur.sessionTime) ? cur.sessionTime : Number(cur.time) || 0;
        dispatch({
          type: 'ADD_VENT_SAMPLE',
          payload: {
            time: t,
            mode: String(d.mode || ''),
            niv: niv,
            vte: num(mon.vte),
            ibw: num(d.ibw),
            ppeak: num(mon.ppeak),
            pplat: num(mon.pplat),
            peep: num(mon.peep),
            autopeep: num(mon.autopeep),
            mv: num(mon.mv),
            ftot: num(mon.ftot),
            o2: num(d.o2),
            setPeep: num(set.peep),
            ipap: niv && num(set.peep) !== null && drive !== null ? set.peep + drive : null
          }
        });
      };
      take();
      var id = setInterval(take, 15000);
      return function () {
        return clearInterval(id);
      };
    }, [isMonitorMode, ventDriving, state.isFinished]);
    var ventDrivingRef = useRef(false);
    useEffect(function () {
      if (isMonitorMode || ventDrivingRef.current === ventDriving) return;
      ventDrivingRef.current = ventDriving;
      if (stateRef.current.isFinished) return;
      if (ventDriving) {
        var held = ['spO2', 'rr', 'etco2'].filter(function (k) {
          return state.manualHold && state.manualHold[k];
        });
        addLogEntry("Ventilator is breathing for the patient: SpO2, RR and ETCO2 now follow it".concat(held.length ? " (except ".concat(held.join(', '), ", which you set by hand)") : '', "."), 'system');
        var cur = stateRef.current;
        // Ventilator Sim: the clock starts itself when the ventilator first breathes for the
        // patient, as Defib Sim's does at the learner's first press, so a forgotten START
        // does not leave every log time at 00:00. Not after a deliberate pause.
        if (cur.scenario && cur.scenario.ventSim && !cur.isRunning && !cur.isFinished && (cur.pausedAt === null || cur.pausedAt === undefined)) {
          addLogEntry('Clock started automatically when the ventilator started.', 'system');
          start();
        }
        var f = window.VENT_ENGINE.interfaceFor(cur);
        if (f.source === 'assumed') {
          addLogEntry("No airway recorded: the patient is unconscious, so the ventilator assumes a tube or SGA is in place.", 'info');
        }
      } else {
        addLogEntry('Ventilator is no longer breathing for the patient (standby, switched off, or the link was turned off). The obs follow the usual model again.', 'system');
      }
    }, [isMonitorMode, ventDriving]);

    // An awake patient with no airway is on a face mask: the log says when the ventilator is put
    // on a mode that needs a tube or SGA (they fight it and the mask leaks), and when that stops.
    var maskWrongRef = useRef(false);
    useEffect(function () {
      if (isMonitorMode) return;
      var cur = stateRef.current;
      var d = window.VENT_ENGINE && window.VENT_ENGINE.driverFor(cur);
      var wrong = !!(d && d.phys && Number(d.phys.mw) > 0);
      if (wrong === maskWrongRef.current || cur.isFinished) {
        maskWrongRef.current = wrong;
        return;
      }
      maskWrongRef.current = wrong;
      var VP = window.VENT_PROFILES;
      var ok = window.VENT_ENGINE.maskModes(cur.vent && cur.vent.model).map(function (m) {
        var row = VP ? VP.modesFor(VP.modelOf(cur.vent && cur.vent.model)).find(function (r) {
          return r[0] === m;
        }) : null;
        return row ? row[1] : m;
      }).join(', ');
      if (wrong) addLogEntry("Awake patient with no airway, on a face mask, but the ventilator is in ".concat(d.label || d.mode, ": they fight it and the mask leaks. A mask suits ").concat(ok, "; other modes need a tube or SGA."), 'warning', true);else if (d) addLogEntry("Ventilator now in ".concat(d.label || d.mode, ": a mode the masked patient tolerates, or their airway has changed."), 'system');
    }, [isMonitorMode, state.ventMirror]);

    // What each ventilator is showing (mode, settings, measured values, alarms), for the
    // facilitator's Ventilator section. Stale after 60 s, like the defib mirror.
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || isMonitorMode) return;
      var ref = db.ref("sessions/".concat(sessionID, "/ventState"));
      // Re-filtered every 10 s as well as on each change: a tablet that vanished without its
      // onDisconnect firing sends no further value, and must still drop out after 60 s.
      var latest = {};
      var lastKeys = '';
      var _push = function push() {
        var now = Date.now();
        var fresh = {};
        Object.keys(latest).forEach(function (k) {
          if (latest[k] && Number(latest[k].ts) > now - 60000) fresh[k] = latest[k];
        });
        var keys = Object.keys(fresh).sort().join(',');
        if (_push.fromValue || keys !== lastKeys) dispatch({
          type: 'SET_VENT_MIRROR',
          payload: fresh
        });
        lastKeys = keys;
      };
      var onVal = function onVal(snap) {
        latest = snap.val() || {};
        _push.fromValue = true;
        _push();
        _push.fromValue = false;
      };
      ref.on('value', onVal, function () {});
      var sweep = setInterval(_push, 10000);
      return function () {
        clearInterval(sweep);
        ref.off('value', onVal);
      };
    }, [isMonitorMode, sessionID]);

    // What each defib tablet is displaying, so a remote facilitator sees the device.
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || isMonitorMode) return;
      var ref = db.ref("sessions/".concat(sessionID, "/deviceState"));
      // Re-filtered every 10 s as well as on each change: a tablet that vanished without its
      // onDisconnect firing sends no further value, and must still drop out after 60 s.
      var latest = {};
      var lastKeys = '';
      var _push2 = function push() {
        var now = Date.now();
        var fresh = {};
        Object.keys(latest).forEach(function (k) {
          if (latest[k] && Number(latest[k].ts) > now - 60000) fresh[k] = latest[k];
        });
        var keys = Object.keys(fresh).sort().join(',');
        if (_push2.fromValue || keys !== lastKeys) dispatch({
          type: 'SET_DEVICE_MIRROR',
          payload: fresh
        });
        lastKeys = keys;
      };
      var onVal = function onVal(snap) {
        latest = snap.val() || {};
        _push2.fromValue = true;
        _push2();
        _push2.fromValue = false;
      };
      ref.on('value', onVal, function () {});
      var sweep = setInterval(_push2, 10000);
      return function () {
        clearInterval(sweep);
        ref.off('value', onVal);
      };
    }, [isMonitorMode, sessionID]);

    // Persist a slim snapshot to localStorage every 5s. This is a single interval keyed only on
    // isMonitorMode: the previous effect re-ran on every vitals tick, and its cleanup cleared the
    // pending timeout each time, so at 1Hz the 5s write never actually fired and resume was dead.
    useEffect(function () {
      if (isMonitorMode) return;
      var id = setInterval(function () {
        try {
          var cur = stateRef.current;
          if (!cur.scenario || cur.log.length === 0 || cur.isFinished) return;
          var slim = {
            // The whole scenario, not just an identifier: every screen dereferences fields
            // like patientProfileTemplate, and a stub makes them throw on resume.
            scenario: cur.scenario,
            vitals: cur.vitals,
            baseVitals: cur.baseVitals,
            prevVitals: cur.prevVitals,
            trends: cur.trends,
            hypoxiaTimer: cur.hypoxiaTimer,
            activeDrugs: cur.activeDrugs,
            deteriorationMode: cur.deteriorationMode,
            // The per-run id travels with the snapshot so a resumed session reopens
            // the same instructor notes instead of a blank set.
            runId: cur.runId || null,
            rhythm: cur.rhythm,
            time: cur.time,
            sessionTime: cur.sessionTime,
            cycleTimer: cur.cycleTimer,
            activeInterventions: Array.from(cur.activeInterventions),
            interventionCounts: cur.interventionCounts,
            activeDurations: cur.activeDurations,
            completedObjectives: Array.from(cur.completedObjectives),
            log: cur.log.slice(-1500),
            // a ventilator session logs every setting change; 200 lost its start
            // The debrief's obs graph (one sample per 5 s; about 2.8 h kept).
            history: (cur.history || []).slice(-2000),
            nibp: cur.nibp,
            etco2Enabled: cur.etco2Enabled,
            isParalysed: cur.isParalysed,
            paralysis: cur.paralysis,
            showWetflag: cur.showWetflag,
            icp: cur.icp,
            // Obs the facilitator set by hand, and point-of-care readings, must survive a
            // resume: without them a held HR went back under AUTO and the BM vanished.
            manualHold: cur.manualHold || {},
            pocReadings: cur.pocReadings || {},
            cprInProgress: !!cur.cprInProgress,
            // The ventilator record behind the debrief's ventilator feedback.
            ventSamples: (cur.ventSamples || []).slice(-800),
            ventPhys: cur.ventPhys || null,
            // Shock count / cumulative energy must survive a resume.
            defib: cur.defib,
            lastConversion: cur.lastConversion,
            defibSettings: cur.defibSettings,
            arrest: cur.arrest,
            defibStep: cur.defibStep,
            vent: cur.vent || null,
            // What the room monitor shows and sounds like: without these, a resumed session
            // took the ventilator and defib off the monitor and reset the capnography shape.
            ventPanelOpen: !!cur.ventPanelOpen,
            defibPanelOpen: !!cur.defibPanelOpen,
            etco2Pathology: cur.etco2Pathology || 'normal',
            audioOutput: cur.audioOutput,
            isMuted: !!cur.isMuted,
            waveformGain: cur.waveformGain,
            noise: cur.noise,
            metronomeOn: !!cur.metronomeOn,
            hypoxiaDeficit: cur.hypoxiaDeficit || 0,
            investigationsRevealed: cur.investigationsRevealed || {},
            // A paced patient, the pacer, its capture threshold, the ventilator link and the
            // skills checklist: without them a resumed paced patient stayed 'Paced' with the
            // pacer off, and the checklist ticks were lost.
            pacing: cur.pacing || null,
            remotePacerState: cur.remotePacerState || null,
            pacingThreshold: cur.pacingThreshold,
            ventLink: cur.ventLink !== false,
            assessments: cur.assessments || {}
          };
          localStorage.setItem('wmebem_sim_state', JSON.stringify(slim));
        } catch (e) {
          console.warn('localStorage persist failed', e);
        }
      }, 5000);
      return function () {
        return clearInterval(id);
      };
    }, [isMonitorMode]);

    // THE FACILITATOR'S REMOTE CONTROL OF ONE VENTILATOR (phase 3): sessions/<CODE>/ventCmd, read
    // and removed by the ventilator it is addressed to. The ventilator logs what it did.
    var sendVentCommand = function sendVentCommand(to, type, key, val) {
      if (isMonitorMode || !sessionID || !window.db || !to || !type) return false;
      var cmd = {
        type: String(type).slice(0, 12),
        to: String(to).slice(0, 40),
        ts: Date.now()
      };
      if (key !== undefined && key !== null) cmd.key = String(key).slice(0, 16);
      if (Number.isFinite(Number(val)) && val !== null && val !== undefined) cmd.val = Number(val);
      try {
        var ref = window.db.ref("sessions/".concat(sessionID, "/ventCmd"));
        ref.push(cmd)["catch"](function (e) {
          return console.error('Ventilator command failed:', e);
        });
        // Commands nobody picked up (a ventilator that went away) are cleared after 2 minutes.
        ref.once('value').then(function (snap) {
          var v = snap.val() || {};
          Object.keys(v).forEach(function (k) {
            if (v[k] && Number(v[k].ts) < Date.now() - 120000) ref.child(k).remove()["catch"](function () {});
          });
        })["catch"](function () {});
        return true;
      } catch (e) {
        console.error('Ventilator command failed:', e);
        return false;
      }
    };
    return {
      sendDeviceEvent: sendDeviceEvent,
      sendVentCommand: sendVentCommand
    };
  };
  window.__EngineSync = {
    useSessionSync: useSessionSync
  };
})();